
import { Component, Vue } from 'vue-property-decorator';
import {
  getStayList,
  addStay,
  updateStay,
} from '@/api/stay';
import { getStayOptionTypeList } from '@/api/stayOptionType';
import { VueDaumPostcode } from 'vue-daum-postcode';
import { parseConcatNumber } from '@/utils/filters';
import { ElForm } from 'element-ui/types/form';
import { getOptionItemList } from '@/api/optionItem';
import ElementTipTap from '@/components/ElementTipTap/index.vue';

@Component({
  components: {
    VueDaumPostcode,
    ElementTipTap,
  },
})
export default class extends Vue {
  mounted() {
    this.getIntroductionList();
    this.getStay();
  }

  private form: any = {
    reserveTerm: 30,
    name: '',
    introduction: '',
    introductionIdx: null,
    homepage: '',
    address: '',
    addressDetail: '',
    addressCity: '',
    inquiryTel: '',
    news: [
      {
        idx: 1,
        title: '',
        titleDirect: '',
        titleDirectFlg: false,
        content: '',
        dateRange: [],
      },
    ],
    courseInfo: '',
    operTime: {
      operTimeList: [
        {
          idx: 1,
          operStartDow: '월',
          operEndDow: '토',
          operDateRange: ['2024-01-01', '2025-01-01'],
        },
      ],
      breakStartTime: '12:00',
      breakEndTime: '13:00',
      holiday: '월',
    },
    enterInfoList: [
      {
        idx: 1,
        content: '',
      },
    ],
    basicInfo: {
    },
    parkingInfo: '',
    surroundInfo: '',
    comingInfoList: '',
    confirmationInfo: '',
    tags: ['남해여행', '남해핫플', '남해관광', '남해사진', '남해추억'],
    useStatus: true,
    images: [],
  }

  private dowList = [
    '월', '화', '수', '목', '금', '토', '일',
  ]

  private apiUrl = process.env.VUE_APP_BASE_API;

  private introductionList = [];

  private findAddressVisible = false;

  private fileSizeLimit = 5;

  private loading = false;

  private tagInputVisible = false;

  private tagInputValue = '';

  private activeTab = 'basicInfo';

  private validateInquiryTel = (rule:any, value:any, callback:any) => {
    const reqInquiryTel = /^[0-9]{3}-[0-9]{3,4}-[0-9]{4}$/;
    if (!reqInquiryTel.test(value)) {
      callback(new Error('연락처 형식에 맞지 않습니다.'));
    } else {
      callback();
    }
  };

  private rules = {
    reserveTerm: [
      { required: true, message: '식단관리 목적을 선택하세요.', trigger: ['blur', 'change'] },
    ],
    name: [
      { required: true, message: '시설명을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    introduction: [
      { required: true, message: '관광지소개를 선택하세요.', trigger: ['change', 'blur'] },
    ],
    homepage: [
      // { required: true, message: '홈페이지를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    inquiryTel: [
      { required: true, message: '연락처를 입력하세요.', trigger: ['change', 'blur'] },
      { validator: this.validateInquiryTel, trigger: ['change', 'blur'] },
    ],
    address: [
      { required: true, message: '주소를 입력하세요.', trigger: ['change', 'blur'] },
    ],
    operTime: [
      { required: true, message: '운영시간을 입력하세요.', trigger: ['change', 'blur'] },
    ],
    enterInfo: [
      // { required: true, message: '입장안내를 입력하세요.', trigger: ['change', 'blur'] },
      { validator: this.validateEnterInfo, trigger: ['change', 'blur'] },
    ],
    images: [
      { required: true, message: '이미지를 선택하세요.', trigger: ['change', 'blur'] },
    ],
    tags: [
      { required: true, message: '태그를 선택하세요.', trigger: ['change', 'blur'] },
    ],
    checkIn: [
      { required: true, message: '체크인 시간을 입력하세요.', trigger: ['blur', 'change'] },
    ],
    checkOut: [
      { required: true, message: '체크아웃 시간을 입력하세요.', trigger: ['blur', 'change'] },
    ],
  }

  private getStay() {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    this.loading = true;
    getStayList().then((res) => {
      if (res.data.length > 0) {
        this.form = {
          ...this.form,
          ...res.data[0],
        };
      }
    });
    this.loading = false;
  }

  private getIntroductionList() {
    getOptionItemList('STAY_INTRODUCE').then((res) => {
      this.introductionList = res.data;
    });
  }

  private handleFindAddress() {
    this.findAddressVisible = !this.findAddressVisible;
  }

  private handleCompleteFindAddress(data: any) {
    this.handleFindAddress();
    this.form.address = data.roadAddress;
    this.form.addressCity = data.bname1;
    this.form.addressDetail = '';
  }

  private filterInquiryTel() {
    this.form.inquiryTel = parseConcatNumber(this.form.inquiryTel);
  }

  private handleBeforeUpload(uploadFile:File) {
    const fileSizeLimitByMb = this.fileSizeLimit * 1024 * 1024;
    const isImageFile = uploadFile.type.split('/')[0] === 'image';
    if (!isImageFile) {
      this.$message.warning('이미지 파일만 업로드 가능합니다.');
      return false;
    }
    if (uploadFile.size > fileSizeLimitByMb) {
      this.$message.warning(`파일 업로드 최대용량은 ${this.fileSizeLimit}MB입니다.`);
      return false;
    }
    return true;
  }

  private handleRemoveImageFile(file: any) {
    const index = this.form.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > -1) this.form.images.splice(index, 1);
  }

  private handleSuccessUploadImageFile(res: any) {
    this.form.images.push({ fileUid: res.uid });
  }

  private handleClickLeftFile(file: any) {
    const index = this.form.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index > 0) {
      this.form.images.splice(index - 1, 0, this.form.images.splice(index, 1)[0]);
    }
  }

  private handleClickRightFile(file: any) {
    const index = this.form.images.findIndex((imgFile: any) => imgFile.fileUid === file.fileUid);
    if (index < this.form.images.length - 1) {
      this.form.images.splice(index + 1, 0, this.form.images.splice(index, 1)[0]);
    }
  }

  private handleClickSave() {
    (this.$refs.stayForm as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.$confirm('정말 관광지정보를 저장하시겠습니까?', '관광지 정보 저장', {
          confirmButtonText: '저장',
          cancelButtonText: '취소',
          type: 'info',
        }).then(() => {
          if (this.form.idx) {
            updateStay(this.form.idx, this.form).then(() => {
              this.$message.success('관광지 정보가 저장되었습니다.');
              this.getStay();
            });
          } else {
            addStay(this.form).then(() => {
              this.$message.success('관광지 정보가 저장되었습니다.');
              this.getStay();
            });
          }
        });
      }
    });
  }

  private handleClickAddTag() {
    this.tagInputVisible = !this.tagInputVisible;
  }

  private handleAddTag() {
    let inputValue = this.tagInputValue;
    inputValue = inputValue.trim();
    if (inputValue && this.form.tags.length <= 5) {
      this.form.tags.push(inputValue);
    }
    this.tagInputVisible = false;
    this.tagInputValue = '';
  }

  private handleRemoveTag(index: number) {
    this.form.tags.splice(index, 1);
  }

  private handleNewsTitle(index: number) {
    if (this.form.news[index].title === '직접입력') {
      this.form.news[index].title = '';
      this.form.news[index].titleDirectFlag = true;
    } else {
      this.form.news[index].titleDirectFlag = false;
    }
  }

  private handleNewsAdd() {
    const news = {
      idx: 1,
      title: '',
      titleDirect: '',
      titleDirectFlg: false,
      content: '',
      dateRange: [],
    };
    this.form.news.push(news);
  }

  private handleNewsDelete(index: number) {
    this.form.news.splice(index, 1);
  }

  private handleOperTimeAdd() {
    const item = {
      idx: 1,
      operStartDow: '',
      operEndDow: '',
      operDateRange: ['', ''],
    };
    this.form.operTime.operTimeList.push(item);
  }

  private handleOperTimeDelete(index: number) {
    this.form.operTime.operTimeList.splice(index, 1);
  }

  private handleEnterInfoAdd() {
    const item = {
      idx: 1,
      content: '',
    };
    this.form.enterInfoList.push(item);
  }

  private handleEnterInfoDelete(index: number) {
    this.form.enterInfoList.splice(index, 1);
  }

  private getEnterInfoRules(index: number) {
    return this.rules.enterInfo;
  }

  private validateEnterInfo(rule: any, value: any, callback: any) {
    const allValuesFilled = this.form.enterInfoList.every((item: any) => item.content.trim() !== '');
    if (allValuesFilled) {
      callback();
    } else {
      callback(new Error('모든 입력 값을 채워주세요.'));
    }
  }

  private getFirstGroupRules(fieldName: any) {
    return [
      { required: true, message: `${fieldName}을(를) 입력하세요.`, trigger: 'blur' },
      // 다른 규칙들을 필요에 따라 추가
    ];
  }

  private handleChangeEditor(value: any) {
    this.form.courseInfo = value;
  }
}
